export const currency = {
  // TODO: Will be used once we add multi-currency
  getCurrency: (currency: string) => {
    return currency;
  },
};
